import { connect } from 'react-redux';

import AppComponent from './App';

const mapStatetoProps = state => ({
  auth: state.auth,
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStatetoProps,
  mapDispatchToProps,
)(AppComponent);
